import React from 'react';
import styles from './Map.module.scss';

function Map2024() {
    return (
        <div className={styles.imgbox}>
            <img className={styles.centerFit} style={{ maxHeight: '70vh' }} src="/Map_2024.svg" alt="Map 2024" />
        </div>
    );
}

export default Map2024;
